import { API, graphqlOperation } from "aws-amplify";
import * as queries from "../../../../graphql/queries";
import {
  createConversation as apiCreateConversation,
  createConversationMember as apiCreateConversationMember,
  createMessage as apiCreateMessage,
  updateNotification,
  updateMessage,
} from "../../../../graphql/mutations";

export function getConversationIds(providerId) {
  const getProviderConversationsList = /* GraphQL */ `
    query GetProviderConversationList($id: ID!) {
      getOpportunityProvider(id: $id) {
        id
        conversationMembers {
          items {
            conversation {
              messages(limit: 1000) {
                nextToken
                items {
                  isSeen
                  id
                  author
                  senderId
                }
              }
            }
            conversationId
          }
        }
      }
    }
  `;
  return API.graphql(
    graphqlOperation(getProviderConversationsList, {
      id: providerId,
      sortDirection: "DESC",
    })
  );
}

// GOW:TODO - Retrevie status from Conversation Member
export function getAllProviderFollowers(providerId, queryParams) {
  const getProviderFollowers = /* GraphQL */ `
    query GetOpportunityProvider(
      $id: ID!
      $filterFollower: ModelOpportunityProviderFollowerFilterInput
      $filterRouteMap: ModelRouteMapFilterInput
      $filterPost: ModelPostFilterInput
    ) {
      getOpportunityProvider(id: $id) {
        followers(filter: $filterFollower) {
          items {
            seeker {
              firstName
              lastName
              id
              email
              dateOfBirth
              biography
              postcodeArea
              profilePic
              routeMaps(filter: $filterRouteMap) {
                items {
                  id
                }
              }
              posts(filter: $filterPost) {
                items {
                  id
                }
              }
              conversationMembers(
                sortDirection: DESC
                filter: { status: { eq: 1 } }
              ) {
                items {
                  id
                  status
                  conversation {
                    title
                    type
                    updatedAt
                    avatar
                    groupId
                    id
                    members {
                      items {
                        seekerId
                        providerId
                        seeker {
                          lastName
                          firstName
                          id
                          profilePic
                        }
                        provider {
                          id
                          name
                          logo
                          displayName
                        }
                      }
                    }
                    messages(limit: 1000, sortDirection: DESC) {
                      items {
                        body
                        createdAt
                        type
                        isSeen
                        providerId
                      }
                    }
                  }
                }
              }
            }
            startedAt
          }
        }
        conversationMembers {
          items {
            conversationId
          }
        }
      }
    }
  `;
  return API.graphql(
    graphqlOperation(getProviderFollowers, {
      id: providerId,
      filterFollower: queryParams.filterFollower,
      filterRouteMap: queryParams.filterRouteMap,
      filterPost: queryParams.filterPost,
    })
  );
}

export function getSeekerConversations(seekerId) {
  const getSeekerConversations = /* GraphQL */ `
    query GetSeekerConversations($id: ID!) {
      getSeeker(id: $id) {
        firstName
        lastName

        conversationMembers(
          sortDirection: DESC
          filter: { status: { eq: 1 } }
        ) {
          items {
            id
            conversation {
              title
              type
              updatedAt
              avatar
              groupId
              id
              members {
                items {
                  seekerId
                  providerId
                  seeker {
                    lastName
                    firstName
                    profilePic
                  }
                }
              }
              messages(limit: 1, sortDirection: DESC) {
                items {
                  body
                  createdAt
                  type
                }
              }
            }
          }
        }
      }
    }
  `;
  return API.graphql(
    graphqlOperation(getSeekerConversations, { id: seekerId })
  );
}

export function createConversation(conversationForCreation) {
  return API.graphql(
    graphqlOperation(apiCreateConversation, { input: conversationForCreation })
  );
}

export function createConversationmember(conversationMemberForCreation) {
  return API.graphql(
    graphqlOperation(apiCreateConversationMember, {
      input: conversationMemberForCreation,
    })
  );
}
export function getConversationMessages(conversatonId, queryParams) {
  return API.graphql(
    graphqlOperation(queries.messagesByConversationId, {
      conversationId: conversatonId,
      sortDirection: "DESC",
    })
  );
}
export function createMessage(messageForCreation) {
  return API.graphql(
    graphqlOperation(apiCreateMessage, { input: messageForCreation })
  );
}

export function getNotifications({ providerId }) {
  return API.graphql(
    graphqlOperation(queries.listNotifications, {
      filter: { recipientId: { eq: providerId } },
      limit: 10000,
    })
  );
}

export function markNotificationAsRead({ notificationId }) {
  return API.graphql(
    graphqlOperation(updateNotification, {
      input: {
        id: notificationId,
        read: true,
        opened: true,
      },
    })
  );
}

export function updateUserMessage(messageToUpdate) {
  return API.graphql(
    graphqlOperation(updateMessage, { input: messageToUpdate })
  );
}
